import { spacesState } from '@/state';
import { useAsyncAtomValue } from '@/state/loadableHooks';
import type { SpaceId } from '@rock/types';
import type { FC } from 'react';

/** Space ids as the names the app shows. */
export const SpaceNames: FC<{ spaceIds: readonly SpaceId[] }> = ({ spaceIds }) => {
    const spaces = useAsyncAtomValue(spacesState, []);
    if (spaceIds.length === 0) return <span>—</span>;
    const names = new Map(spaces.map((space) => [space.id, space.name]));
    return <span>{spaceIds.map((id) => names.get(id) ?? id).join(', ')}</span>;
};
